module.exports = __webpack_public_path__ + "img/janaina-ramon.1a0f8b4a.png";